import(/* webpackMode: "eager" */ "/app/src/app/(landing-page)/(static-pages)/creator-guide/video-creator-india/page.tsx")